import { useFormik } from "formik";
import { useTranslation } from "next-i18next";
import * as yup from "yup";
import { CustomerRequestedPortalData } from "./customer-requested-portal-model";

/**
 * Manages form data for the requested portal step.
 * @param onNext a call back that signals submission
 * @returns a formik instance
 */
export function useCustomerRequestedPortalFormik(
  onNext: (data: CustomerRequestedPortalData) => void
) {
  const { t } = useTranslation();
  const other = t("request_access:more_information.other");
  const australia = t("request_access:more_information.australia");
  const messageRequired = t("common:common.required");

  const validationSchema = yup.object().shape({
    cargillBusiness: yup.string().required(messageRequired),
    appRefName: yup.string().required(messageRequired),

    country: yup.string().when("cargillBusiness", {
      is: (value: string) => value === other || value === australia,
      then: yup.string().notRequired(),
      otherwise: yup.string().required(messageRequired),
    }),
  });

  const formik = useFormik<CustomerRequestedPortalData>({
    initialValues: {
      cargillBusiness: "",
      appRefName: "",
      country: "",
      requestReason: "",
      accessReason: "",
    },
    validationSchema: validationSchema,
    onSubmit: (values) => {
      onNext(values);
    },
  });

  return formik;
}
